import { Component, ComponentFactoryResolver, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router'
import { MatSnackBar } from '@angular/material/snack-bar';
import { SettingsService } from '../settings/settings.service';

import { environment } from '../environments/environment';

@Component({
    selector: 'app-home-lemu',
    templateUrl: './home-lemu.component.html',
    styleUrls: ['./home-lemu.component.less'],
    standalone: false
})


export class HomeLemuComponent implements OnInit {

  public systems:any=[];


  constructor(public snackBar: MatSnackBar, public settings: SettingsService, private router: Router) { }


  randomImage: string = '';
  private images: string[] = [
    '../../assets/images/33.jpg',
    '../../assets/images/3.jpg',
    '../../assets/images/4.jpg',
    '../../assets/images/7.jpg',
    '../../assets/images/9.jpg',
    '../../assets/images/12.jpg',
    '../../assets/images/14.jpg',
    '../../assets/images/17.jpg',
    '../../assets/images/23.jpg',
    '../../assets/images/2.jpg',
    '../../assets/images/15.jpg',
    '../../assets/images/26.jpg',
  ];

 setRandomBackground(): void {
   const randomIndex = Math.floor(Math.random() * this.images.length);
   this.randomImage = this.images[randomIndex];
 }

  ngOnInit() {
    this.setRandomBackground();
    this.verify();
    this.get_personal_data();

  }

  verify()
  {
    if (localStorage.getItem("token") == null )
    {
     this.router.navigate(['login']);
    }
  }

  logout()
  {
    localStorage.clear()
    this.router.navigate(['login']);
  }


  user:any="";
  avatar:any=null;
  has_avatar:boolean=false;
  loading:boolean=false;
  aux:any[]=[];
  public async get_personal_data() {
    this.loading = true;
    let resultado:any = (await this.settings.get_query(1, 'user/'))
    let body_data=resultado;

    if(!body_data['error']){


      let roles = body_data.user.roles;

      this.user = body_data.user.first_name + ' ' + body_data.user.last_name;
      this.avatar = body_data.user.avatar;

      if(body_data.user.avatar == null || body_data.user.avatar == "" || body_data.user.avatar == undefined){
        this.has_avatar = false
      }else{
        this.has_avatar = true;
      }

      this.aux = []

      for (let i=0; i < roles.length; i++)
      {
        for (let j=0; j < roles[i].systems.length; j++)
        {
          let s = roles[i].systems[j]

          if(this.aux.some(element => element.id === s.id))
          {
            console.log("found")
          }
          else
          {
            this.aux.push(s)
          }
        }
      }





     this.loading = false;



    }else{
      console.error("error")
      this.loading = false
      localStorage.clear();
      this.router.navigate(['login']);
    }
  }


  navegar(initials:any, name:any, url:any)
  {
      if (initials == "Ve")
      {
          location.replace(environment.lemu_base+"/login/?email="+localStorage.getItem("email")+"&password="+localStorage.getItem("xrp"));
      }
      else
      {
          if(name=="Ventas" && localStorage.getItem("role")=="admi")
          {
              location.replace(SettingsService.lemu_base + url + "/#/home/admin");
          }
          else
          if (initials == "Tb")
              location.replace(SettingsService.lemu_base + url + "");
          else
              location.replace(SettingsService.lemu_base + url + "/#/home");





          if(name=="Cobranza" && (localStorage.getItem("role")=="ecom" || localStorage.getItem("role")=="eneg" ) )
              location.replace(SettingsService.lemu_base + url + "/#/home/cartera");

      }
  }


}

